(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/teams/assets/javascripts/teams.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/teams/assets/javascripts/teams.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useState,
  useEffect,
  useRef
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  selectTeams
} = svs.components.marketplaceCompetition.services.selectors;
const {
  fetchTeams
} = svs.components.marketplaceCompetition.services.actions.teamsActions;
const {
  ReactPaper,
  ReactIcon
} = svs.ui;
const {
  getTeamStatus
} = svs.components.marketplaceCompetition.services.helpers.teamHelper;
const {
  useCompetition,
  useCompetitionBranding,
  usePlayerCompetitions
} = svs.components.marketplaceCompetition.services.hooks;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  Link,
  useRouteMatch,
  useHistory,
  useLocation
} = ReactRouterDOM;
const {
  CreateTeamContainer
} = svs.components.marketplaceCompetition.teams;
const {
  TeamPage
} = svs.components.marketplaceCompetition.teamPage;
const {
  useIsBeforeSignupStartTime,
  useIsBeforeSignupEndTime
} = svs.components.marketplaceCompetition.team.useCompetitionSignupTime;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  selectPlayerCompetitionsStatus
} = svs.components.marketplaceCompetition.services.selectors.playerCompetitionSelectors;
const {
  RejectedPlayer
} = svs.components.marketplaceCompetition.common;
const {
  FetchState
} = svs.components.marketplaceCompetition.constants;
const {
  useFocusTrap
} = svs.components.lbUtils;
const Teams = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const competitionId = useCompetitionId();
  const competition = useCompetition(competitionId);
  const competitionBranding = useCompetitionBranding(competition === null || competition === void 0 ? void 0 : competition.compType);
  const {
    data: teams
  } = useSelector(state => selectTeams(state, competitionId));
  const teamsArray = teams ? Object.values(teams) : [];
  const {
    params
  } = useRouteMatch();
  const [currentTeamId, setCurrentTeamId] = useState(params.teamId ? parseInt(params.teamId, 10) : undefined);
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_MD));
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const hasTeamsControls = (teamsArray === null || teamsArray === void 0 ? void 0 : teamsArray.length) > 0;
  const playerCompetitions = usePlayerCompetitions();
  const [status] = useSelector(selectPlayerCompetitionsStatus);
  const playerCompetitionIds = Object.keys(playerCompetitions);
  const competitionIds = playerCompetitionIds.map(compId => parseInt(compId, 10));
  const isParticipating = playerCompetitions && competitionIds.find(id => id === competitionId);
  const isBeforeSignupStartTime = useIsBeforeSignupStartTime({
    competition
  });
  const isBeforeSignupEndTime = useIsBeforeSignupEndTime({
    competition
  });
  const registrationOpen = !isBeforeSignupStartTime && isBeforeSignupEndTime;
  const canCreateTeam = (!teamsArray || (teamsArray === null || teamsArray === void 0 ? void 0 : teamsArray.length) < 5) && registrationOpen;
  const {
    trapFocus,
    releaseFocus
  } = useFocusTrap({
    refocus: true
  });
  const desktopTeamRef = useRef(null);
  const focusTargetRef = useRef(null);
  const location = useLocation();

  let focusParam = null;
  try {
    const qs = new URLSearchParams(location.search);
    focusParam = qs.get('focus'); 
  } catch (e) {
    focusParam = null;
  }
  const focusTeamId = focusParam && focusParam.startsWith('team-') ? parseInt(focusParam.split('team-')[1], 10) : undefined;
  const focusCreate = focusParam === 'create';
  useEffect(() => {
    if (currentTeamId && desktopTeamRef.current) {
      setTimeout(() => trapFocus(desktopTeamRef.current), 0);
    }
    let elementToFocus = null;
    try {
      if (focusParam) {
        elementToFocus = focusTargetRef.current || null;
      }
    } catch (e) {
      elementToFocus = null;
    }
    if (elementToFocus) {
      const qs = new URLSearchParams(location.search);
      qs.delete('focus');
      history.replace(_objectSpread(_objectSpread({}, location), {}, {
        search: qs.toString() ? "?".concat(qs.toString()) : ''
      }));
    }
    releaseFocus(elementToFocus);
  }, [currentTeamId, desktopTeamRef, trapFocus, releaseFocus, params.competitionName, location, location.search, focusParam, history]);
  useEffect(() => {
    if (isParticipating) {
      dispatch(fetchTeams(competitionId));
    }
  }, [teams, competition, dispatch, competitionId, isParticipating]);
  const Header = () => React.createElement("h2", {
    className: "competition-teams-header"
  }, "Lag");
  const renderTeam = team => React.createElement(ReactPaper, {
    branding: "sport"
  }, React.createElement("div", {
    className: "team-item fc-navy ".concat(competitionBranding, " ").concat(team.id === currentTeamId ? 'selected' : '')
  }, React.createElement("div", {
    className: "team-item-header"
  }, React.createElement(ReactIcon, {
    color: "fc-navy",
    icon: "players",
    size: "600"
  })), React.createElement("div", {
    className: "team-item-info"
  }, React.createElement("div", {
    className: "team-item-name f-medium"
  }, team.name), React.createElement("div", {
    className: "team-item-status fc-grey-500"
  }, getTeamStatus({
    team,
    competition
  })))));
  const renderTeamsList = () => teamsArray.map(team => React.createElement(React.Fragment, {
    key: team.data.id
  }, React.createElement(Link, {
    className: "qa-team-link team-link",
    onClick: () => {
      const base = "/tavlingar/".concat(params.competitionName, "/lag/").concat(team.data.id);
      if (!isSmall) {
        const newTeamId = team.data.id === currentTeamId ? undefined : team.data.id;
        if (newTeamId !== undefined) {
          setCurrentTeamId(newTeamId);
        }
      }
      history.push(base);
    },
    ref: team.data.id === focusTeamId ? focusTargetRef : undefined,
    to: "/tavlingar/".concat(params.competitionName, "/lag/").concat(team.data.id)
  }, renderTeam(team.data))));
  if (status === FetchState.Rejected) {
    return React.createElement(RejectedPlayer, {
      activeOnly: true,
      InnerComponent: ReactPaper,
      text: "F\xF6r tillf\xE4llet g\xE5r det inte att visa n\xE5gon personlig information om t\xE4vlingen."
    });
  }
  if (!isLoggedIn) {
    return null;
  }
  if (!registrationOpen && !hasTeamsControls && !currentTeamId) {
    return null;
  }
  if (!hasTeamsControls && registrationOpen && !currentTeamId) {
    return React.createElement("div", {
      className: "competition-overview-teams"
    }, React.createElement(Header, null), React.createElement("div", {
      className: "team-items-holder",
      "data-testid": "qa-team-items-holder"
    }, React.createElement("div", {
      className: "qa-init-create-team",
      ref: focusCreate ? focusTargetRef : undefined
    }, React.createElement(CreateTeamContainer, {
      competitionId: competitionId,
      onClick: () => {
        history.push("/tavlingar/".concat(params.competitionName, "/skapa-lag"));
      }
    }))));
  }
  return React.createElement("div", {
    className: "competition-overview-teams"
  }, React.createElement(Header, null), hasTeamsControls && React.createElement("div", {
    className: "team-items-holder",
    "data-testid": "qa-team-items-holder"
  }, renderTeamsList(), canCreateTeam && React.createElement("div", {
    className: "qa-init-create-team",
    ref: focusCreate ? focusTargetRef : undefined
  }, React.createElement(CreateTeamContainer, {
    competitionId: competitionId,
    onClick: () => {
      history.push("/tavlingar/".concat(params.competitionName, "/skapa-lag?focus=create"));
    }
  }))), currentTeamId && React.createElement("div", {
    className: "desktop-team-paper-holder",
    ref: desktopTeamRef
  }, React.createElement(ReactPaper, {
    branding: "sport",
    href: "/"
  }, React.createElement("div", {
    className: "desktop-team-view-holder bg-white"
  }, React.createElement("div", {
    className: "desktop-left-view"
  }, React.createElement(TeamPage, {
    currentTeamId: currentTeamId
  })), React.createElement("div", {
    className: "desktop-right-view"
  }, React.createElement("div", {
    className: "close-holder"
  }, React.createElement(Link, {
    className: "qa-close-team-view",
    onClick: () => {
      setCurrentTeamId(undefined);
    },
    to: "/tavlingar/".concat(params.competitionName, "?focus=team-").concat(currentTeamId)
  }, React.createElement(ReactIcon, {
    className: "icon-close",
    color: "fc-navy",
    icon: "close",
    size: "300"
  }), "St\xE4ng")))))));
};
setGlobal('svs.components.marketplaceCompetition.teams.Teams', Teams);

 })(window);